<template lang="pug">
	.audio-tracker-tools--clip-settings.flex-col.space
		.flex-row.justify.space.align-center
			span {{$tCaption('Speed')}} ({{$Data.formatNumber(playbackRate, '0.0#')}})
			DxSlider(:min="0.5", :max="2", :value="playbackRate", :width="200", :step="0.01", @value-changed="e => $emit('update:playbackRate', e.value)")
		.flex-row.justify.space.align-center
			span {{$tCaption('Pitch')}} ({{$Data.formatNumber(pitchRate, '0.0#')}})
			DxSlider(:min="0.5", :max="2", :value="pitchRate", :width="200", :step="0.01", @value-changed="e => $emit('update:pitchRate', e.value)")
		.flex-row.justify.space.align-center
			span {{$tCaption('Volume')}} ({{$audioHelper.gainToDbText(volumeRate)}})
			DxSlider(:min="0", :max="3", :value="volumeRate", :width="200", :step="0.001", @value-changed="e => $emit('update:volumeRate', e.value)")
		.spacer
		.flex-row.space
			DxCheckBox(:text="$tCaption('Mute')", :value.sync="muted")
</template>
<script>		
	import DxSlider from 'devextreme-vue/slider';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		translationCategory: 'audioTracker.AudioTrackerTools',
		name: 'audio-tracker-tools--clip-settings',
		components: { DxSlider, DxCheckBox },
		props: ['track', 'tracker', 'playbackRate', 'pitchRate', 'volumeRate', 'clipMuted'],
		data() {
			return {
			};
		},
		computed: {
			muted: {
				get: function() { return this.clipMuted || false; },
				set: function(v) { this.$emit('update:clipMuted', v || false) }
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.toolsClip = this;

		},
		destroyed() {
		},
		methods: {			
			
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-tools--clip-settings {
		padding-bottom: 10px;
	}
</style>
